var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.list),function(item){return _c('policy-item',{key:item,attrs:{"name":item,"disabled":_vm.isFrozen}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }